import { BRAND } from '@rydres/shared';

/**
 * The store badges, shown once the app is published (VITE_APP_LINKS=on at build). Before that,
 * `?apps` on any page previews them; the links answer "not available" until release.
 */
export const appLinksShown = () => import.meta.env.VITE_APP_LINKS === 'on' || new URLSearchParams(location.search).has('apps');

/** The phone's own store only; both on a computer. */
const platform = () => (/iPhone|iPad|iPod/.test(navigator.userAgent) ? 'ios' : /Android/.test(navigator.userAgent) ? 'android' : 'both');

export function AppBadges({ small }: { small?: boolean }) {
  const which = platform();
  const h = small ? 34 : 44;
  return (
    <div className="flex flex-wrap items-center gap-3">
      {which !== 'android' && (
        <a href={BRAND.apps.appStore} target="_blank" rel="noreferrer">
          <img src="/badges/app-store.svg" alt="Download on the App Store" style={{ height: h }} />
        </a>
      )}
      {which !== 'ios' && (
        // Google's badge carries its own padding: drawn larger so the badges line up.
        <a href={BRAND.apps.googlePlay} target="_blank" rel="noreferrer" className="-my-2">
          <img src="/badges/google-play.png" alt="Get it on Google Play" style={{ height: Math.round(h * 1.45) }} />
        </a>
      )}
    </div>
  );
}
